import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PredefinedSkillType} from "../../../skills/types/predefined-skill.type";
import {SplitService} from "../../services/split-service.service";

export class SkillTagsComponent implements IController {
  skillsIds: any;
  hideDescription: boolean;
  limit: number = 2;


  public tags: any[] = [];
  public visible:boolean;

  public predefinedSkillTypesMap: typeof PredefinedSkillType = PredefinedSkillType;
  private siteSkills: any[]

  constructor(private $filter, private splitService: SplitService) {
    this.siteSkills = splitService.getSiteResourceSkills();
  }

  $onInit() {
    this.tags = [];
    this.setTags();
  };

  $onChanges(changes) {
    if (changes.skillsIds && !changes.skillsIds.isFirstChange()) {
      this.$onInit();
    }
  };

  private setTags() {
    this.tags = _.map(this.skillsIds, (sId) => {
      return this.siteSkills[sId];
      // const skill = this.siteSkills[sId];
      //
      // const text = this.predefinedSkillTypesMap[sId] ? this.$filter('translate')('SKILLS.' + sId) : skill ? skill.name : sId;
      // return {
      //   text: this.firstLetterOnly ? skill.name.charAt(0) : skill.name,
      //   description: this.predefinedSkillTypesMap[sId] ? this.$filter('translate')('SKILLS_DESCRIPTION.' + sId) : skill ? skill.description : sId,
      //   skill: skill
      // }
    })
  }
}

angular
  .module('bringoz.admin.commons')
  .component('skillTags', {
    bindings: {
      skillsIds: '<',
      firstLetterOnly: '<?',
      limit: '<?',
      hideDescription: '<?'
    },
    template: require('./skill-tags.html').default,
    controller: SkillTagsComponent
  });
